import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import { deleteVesselSale } from 'actions/vessels/sales';
import { execute } from 'store/configureStore';
import { saveRequestsDataDeleted } from 'sagas/orders';
import OpenMailBlock from '../../Base/Mails/OpenMailBlock';
import BasicChip from '../../Base/Chips/BasicChip';

const Item = ({ item, deleteVesselSale }) => {
    const handleSaveRequestsDataDeleted = async () => {
        try {
            await execute(saveRequestsDataDeleted, 'vessel', { mailId: item.mailId });
        } catch (error) {
            console.error(error);
        }
    };

    const deleteVesselRequest = () => {
        if (item.mailId) {
            handleSaveRequestsDataDeleted();
        }
        deleteVesselSale(item._id);
    };

    const managementBlock = (
        <div className='paper-block'>
            <div className='name-block absolute small-name'>Managment</div>
            <div style={{ display: 'flex', position: 'absolute', top: '30px', right: '20px', gap: '10px', alignItems: 'center' }}>
                <span>Added at: {moment(item.createdAt).format('MM-DD-YYYY')}</span>
                {item.outdated && (
                    <BasicChip
                        label='Outdated'
                        style={{ backgroundColor: '#f44336', color: '#fff', width: 'fit-content' }}
                    />
                )}
            </div>
            {
                item.deleteBy ? (
                    <React.Fragment>
                        <div className='name-block absolute small-name'>Deleted</div>
                        <span>Delete at: </span>{moment(item.deleteAt).format('MM-DD-YYYY')}<br />
                        <span>Delete by: </span>{_.has(item, 'deleteBy.email') ? item.deleteBy.email : ''}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <RaisedButton
                            onClick={deleteVesselRequest}
                            label='Delete'
                            style={{ margin: '0 10px 0 0' }}
                            secondary
                        />
                    </React.Fragment>
                )
            }
        </div>
    );

    return (
        <div className='paper-block item-request'>
            <div className='col col-4'>
                <div className='paper-block'>
                    <div className='name-block absolute small-name'>unique info</div>
                    <span>refNo: </span>{item.refNo}
                </div>

                <div className='paper-block'>
                    <div className='name-block absolute small-name'>info</div>
                    <span>name: </span>{item.vesselData.name}<br />
                    <span>dwt: </span>{item.vesselData.deadWeight.sDWT}<br />
                    <span>imoNumber: </span>{item.vesselData.imoNumber}<br />
                </div>
            </div>

            <div className='col col-4'>
                <div className='paper-block'>
                    <div className='name-block absolute small-name'>Company</div>
                    <span>Name: </span>{_.has(item, 'companyData.name') ? item.companyData.name : ''}
                </div>
                <div className='paper-block'>
                    <div className='name-block absolute small-name'>User</div>
                    <span>Name: </span>{item.userData.name}<br />
                    <span>Surname: </span>{item.userData.surname}<br />
                    <span>Surname: </span>{item.userData.email}<br />
                </div>
            </div>

            <div className='col col-4'>
                {
                    item.salePrice || item.ideaPrice ? 
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Sale info</div>
                            {
                                item.salePrice ? (
                                    <div>
                                        <span>Sale price: </span>{ item.salePrice }<br />
                                    </div>
                                ) : null
                            }
                            {
                                item.ideaPrice ? (
                                    <div>
                                        <span>Idea price: </span>{ item.ideaPrice}<br />
                                    </div>
                                ) : null
                            }
                        </div>
                        :
                        null
                }
                {
                    item.realUserEmail && (
                        <div className='paper-block'>
                            <div className='name-block absolute small-name'>Real user</div>
                            <span>Email: </span>{item.realUserEmail}<br />
                        </div>
                    )
                }
                {managementBlock}
                {item.mailId && <OpenMailBlock mailId={item.mailId} />}
            </div>
        </div>
    );
};

export default connect(
    (state, ownProps) => {
        return {
        };
    },
    dispatch => bindActionCreators({ deleteVesselSale }, dispatch),
)(Item);



// WEBPACK FOOTER //
// ./app/components/Vessels/Sales/Item.jsx